import { getApiClient } from './client';
import type { Container } from '@/types/domain';

export interface M365Group {
  id: string;
  displayName?: string;
  description?: string | null;
  mail?: string | null;
}

export async function list365Groups(q?: string): Promise<M365Group[]> {
  return getApiClient()
    .get('outlook-list-365-groups', { searchParams: q ? { q } : undefined })
    .json<M365Group[]>();
}

export interface CreateSpaceArgs {
  name: string;
  m365GroupId?: string;
  newGroup?: {
    displayName: string;
    mailNickname: string;
    description?: string;
    visibility?: 'Private' | 'Public';
    owners?: string[];
  };
}

export async function createSpace(args: CreateSpaceArgs): Promise<Container> {
  return getApiClient().post('outlook-create-space', { json: args }).json<Container>();
}

export interface SetProjectGroupArgs {
  containerId: string;
  m365GroupId?: string;
  newGroup?: {
    displayName: string;
    mailNickname: string;
    description?: string;
    visibility?: 'Private' | 'Public';
    owners?: string[];
  };
}

export interface SetProjectGroupResult {
  containerId: string;
  m365GroupId: string;
  mode: 'bind' | 'create';
}

// Attach a Microsoft 365 group to an existing project that has none (bind an
// existing group or create one). Admin-only.
export async function setProjectGroup(args: SetProjectGroupArgs): Promise<SetProjectGroupResult> {
  return getApiClient()
    .post('outlook-set-project-group', { json: args })
    .json<SetProjectGroupResult>();
}

// A plain object-literal type (not an interface) so it stays assignable to the
// `Record<string, unknown>` breadcrumb payload in useRenameSpace.
export type UpdateSpaceArgs = {
  containerId: string;
  name: string;
};

export interface UpdatedSpace {
  id: string;
  kind: string;
  name: string;
  updatedAt: string;
}

// Rename a team space. Only the local label (outlook.containers.name) changes —
// the underlying Microsoft 365 group displayName is left untouched. Admin-only.
export async function updateSpace(args: UpdateSpaceArgs): Promise<UpdatedSpace> {
  return getApiClient().post('outlook-update-space', { json: args }).json<UpdatedSpace>();
}
